import { Paper } from "@mui/material";
import { useFields } from "../../../../api/useFields";
import { Groups } from "../../../../components/groups/Groups";
import { evaluationsOptions } from "../../../evaluations/evaluationsOptions";
import { EvaluationHeaderData } from "../../../evaluations/EvaluationHeader";

type EvaluationDetailPanelProps = {
	evaluationItem: any;
};

export const EvaluationDetailPanel = ({ evaluationItem }: EvaluationDetailPanelProps) => {
	const { formatedFields } = useFields("evaluations");

	if (!formatedFields) return null;

	return (
		<>
			<Paper sx={{ display: "flex", alignItems: "flex-start", gap: 4, flexWrap: "wrap", mb: 2, mx: 2, p: 2 }} elevation={1}>
				<EvaluationHeaderData evaluation={evaluationItem} />
			</Paper>
			<Groups item={evaluationItem} fields={formatedFields} groupsOptions={evaluationsOptions.groupsOptions} />
		</>
	);
};
